export default __webpack_public_path__ + "static/media/foal-constructor.0d1b21eb.png";